export const RENAME_FOLDER_MODAL_FIELDS = {
  NAME: "name",
} as const;
